import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { getBillEffectiveStatus } from "@common/helpers/accrual-source";
import { Bill, BillStatus } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BillStatus as BillStatusComponent } from "../../../BillStatus";

export const StatusCell = memo(
    ({
        row,
        getValue,
    }: CellContext<ViewTableFeatures, Bill, BillStatus | null>) => {
        const status = getValue() ?? getBillEffectiveStatus(row.original);

        return (
            <ViewTableCell>
                {status ? <BillStatusComponent status={status} /> : null}
            </ViewTableCell>
        );
    },
);
